import { useEffect, useRef, useState } from 'react';

const useAppleAnimation = (animationType = 'apple-slide-up', threshold = 0.1, rootMargin = '0px 0px -100px 0px') => {
  const ref = useRef(null);
  const [hasTriggered, setHasTriggered] = useState(false);

  useEffect(() => {
    // 뷰포트 높이가 매우 짧은 경우 즉시 애니메이션 실행
    const viewportHeight = window.innerHeight;
    if (viewportHeight <= 700 && rootMargin.includes('100%')) {
      const element = ref.current;
      if (element) {
        // 애니메이션 클래스 추가
        if (animationType !== 'staggered-animation') {
          element.classList.add(animationType);
        }
        // 즉시 visible 클래스 추가
        setTimeout(() => {
          element.classList.add('visible');
          setHasTriggered(true);
        }, 100);
        return; // Observer 설정 건너뛰기
      }
    }
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting && !hasTriggered) {
            setHasTriggered(true);
            
            // 새로고침 시에도 애니메이션이 제대로 작동하도록 약간의 지연 추가
            const executeAnimation = () => {
              if (animationType === 'staggered-animation') {
                // 계단식 애니메이션의 경우 모든 자식 요소에 visible 클래스 추가
                const children = entry.target.querySelectorAll('.staggered-animation');
                children.forEach((child) => {
                  child.classList.add('visible');
                });
                entry.target.classList.add('visible');
              } else {
                entry.target.classList.add('visible');
              }
            };
            
            // requestAnimationFrame을 사용해 다음 렌더링 프레임에서 실행
            requestAnimationFrame(() => {
              requestAnimationFrame(executeAnimation);
            });
            
            // 애니메이션이 한 번 실행되면 더 이상 관찰하지 않음
            observer.unobserve(entry.target);
          }
        });
      },
      {
        threshold,
        rootMargin,
      }
    );

    const element = ref.current;
    if (element) {
      // 애니메이션 클래스 추가
      if (animationType !== 'staggered-animation') {
        element.classList.add(animationType);
      }
      observer.observe(element);
    }

    return () => {
      if (element) {
        observer.unobserve(element);
      }
    };
  }, [animationType, threshold, rootMargin, hasTriggered]);

  return ref;
};

export default useAppleAnimation;